module.exports = __webpack_public_path__ + "static/img/wall-conveyor-x2_64.56baa59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-x2_64.png
// module id = 7ZOM
// module chunks = 0